import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import axios from 'axios';
import { bindActionCreators } from 'redux';
import { Route, Redirect } from 'react-router-dom';

import { clearReduxStore } from 'containers/InitialStore';

import * as loginActions from 'modules/login';
import * as userActions from 'modules/user';

import { changeSaas, changeGS, changeEdu, changeDeclare, changeJapan, changePhishing } from 'libs/commonVar';
import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

class AuthRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loginchecked: 0
    };
  }

  componentDidMount() {
    this.checkLoginStatus();

    // api 통신 interceptor 처리
    // 서버에서 401 에러 발생시 로그인 화면으로 이동
    axios.interceptors.response.use(
      response => {
        // Do something with response data
        return response;
      },
      error => {
        if (error.response.status === 401) {
          // 로그아웃 처리
          const { Dispatch } = this.props;
          clearReduxStore(Dispatch, 'logout');

          const { UserActions, LoginActions } = this.props;

          sessionStorage.removeItem('curUser');

          // 로그아웃 처리
          UserActions.logout();
          // 로그인 초기화
          LoginActions.setInitial();
        }
      }
    );
  }

  checkLoginStatus = async () => {
    const { LoginActions, UserActions } = this.props;

    // 여기서 브라우저가 꺼졌다가 새로 켜졌을 경우 redux의 데이터가 없을것이니
    // 데이터가 없다면 checkLogin 요청을 하면 안된다.

    try {
      // GS인증
      if (commonVar.isGs !== 1 || (commonVar.isGs === 1 && !!sessionStorage.getItem('curUser'))) {
        const respObj = await LoginActions.getCheckLogin();

        // 구축형
        if (respObj && respObj.status && respObj.status === 200 && respObj.data && respObj.data.list) {
          changeSaas(respObj.data.list.isSaas);
          changeGS(respObj.data.list.isGs);
          changeJapan(respObj.data.list.isJapan);
          changeEdu(respObj.data.list.isEdu);
          changeDeclare(respObj.data.list.isDeclare);
        }

        const { login, userData, serviceNo, sessionTimeout } = this.props;
        if ('isAdmin' in userData) {
          if (userData.isAdmin === 1) {
            localStorage.setItem('loginAdmin', userData.userEmail);
            localStorage.removeItem('loginUser');
          } else {
            localStorage.removeItem('loginAdmin');
            localStorage.setItem('loginUser', userData.userEmail);
          }

          sessionStorage.setItem('accessTime', common.nowEpoch());

          userData['serviceNo'] = serviceNo;
          UserActions.setUser({ user: userData, sessionTimeout });

          // sessionTimeout
        }
      }
    } catch (e) {
      // 로그인 검사 결과 현재의 인증정보가 유효하지 않음 (실패)
      console.log(e);
    }

    // 로그인 검사를 완료함. 이제부터 render 가 동작함
    this.setState({ loginchecked: 1 });
  };

  render() {
    if (this.state.loginchecked === 0) {
      return null;
    }

    const { component: Component, authType, accessLevel, path: toGo, failPath, componentName } = this.props;

    if (authType === 0) {
      // root경로로 들어왔을 경우 로그인이 되어 있다면 '기존 페이지'로 로그인이 안되어 있다면 '소개 페이지'로
      if (this.props.isAuth === 1) {
        return <Redirect to="/main" />;
      } else if (this.props.isAuth === 2) {
        return <Redirect to="/mudmanage" />;
      } else {
        if (commonVar.isGs !== 1) {
          return <Redirect to="/intro" />;
        } else {
          return <Redirect to="/login" />;
        }
      }
    } else if (authType === 1) {
      // 로그인 성공이면 안되는 컴포넌트
      // 이들 컴포넌트 실행의 성공 결과가 로그인 성공이므로 이곳이 아닌 각 컴포넌트에서 처리해야 한다.
      return <Route path={toGo} render={() => <Component />} />;
    } else if (authType === 2) {
      // 로그인이 반드시 필요한 페이지
      if (this.props.isAuth === accessLevel) {
        // 로그인 권한이 일치함
        return <Route path={toGo} render={props => <Component {...props} />} />;
      } else {
        // 로그인 권한이 없으므로 해당 로그인 페이지로 이동
        return (
          <Redirect
            to={{
              pathname: failPath
            }}
          />
        );
      }
    }
  }
}

AuthRoute.propTypes = {
  failPath: PropTypes.string,
  authType: PropTypes.number.isRequired,
  accessLevel: PropTypes.number.isRequired
};
AuthRoute.defaultProps = {
  failPath: '/login'
};

const mapStateToProps = state => ({
  login: state.login.get('login'),
  userData: state.login.getIn(['login', 'userData']),
  sessionTimeout: state.login.getIn(['login', 'sessionTimeout']),
  serviceNo: state.login.getIn(['login', 'serviceNo']),
  isAuth: state.user.get('isAuth')
});

const mapDispatchToProps = dispatch => ({
  LoginActions: bindActionCreators(loginActions, dispatch),
  UserActions: bindActionCreators(userActions, dispatch),
  Dispatch: dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthRoute);



// WEBPACK FOOTER //
// ./src/script/pages/AuthRoute.js